import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 获取企业应用列表(包含有效期)
  getClients: (enterpriseCode, config) =>
    createAPI(`/v1/admin/realms/${enterpriseCode}/clients`, "get", config),
  // 获取应用api列表
  getApis: (enterpriseCode, clientId, config) =>
    createAPI(
      `/v1/admin/realms/${enterpriseCode}/apis/clients/${clientId}`,
      "get",
      config
    ),
  // 获取报表
  getReport: (enterpriseCode, config) =>
    createAPI(`/v1/admin/realms/${enterpriseCode}/apis/reports`, "get", config)
}
